import Vue from 'vue'
import * as types from '../types'
import apiService from '../../services/api.service'
import storage from '../../services/storage.service'
import router from "../../router";

const state = {
    accessToken: storage.getToken() || null,
    userData: JSON.parse(storage.getItem('userData'))
};

const getters = {
    isAuthenticated: state => !!state.accessToken,
    stateNumber: state => {
        if(state.userData) return state.userData.objectStateN;
    }
};

const actions = {
    [types.REFRESH_TOKEN]: ({commit, dispatch}, refreshToken) => {
        return new Promise((resolve, reject) => {

            let requestData = {
                url: 'api/taxi/driver/auth/refresh',
                method: 'POST',
                data: {refreshToken: refreshToken}
            };

            apiService.sendRequest(requestData).then(resp => {
                console.log('refreshed');
                commit(types.SET_TOKENS, {accessToken: resp.data.accessToken, refreshToken:  resp.data.refreshToken});
                resolve(resp.data.accessToken);

            }).catch(err => {
                dispatch(types.AUTH_LOGOUT).then(()=>{
                    router.push({name: 'authorization'})
                }).catch(err =>{
                    console.log(err);
                });
                reject(err);
            });
        })
    },

    [types.AUTH_LOGOUT]: ({commit, rootState}) => {
        return new Promise((resolve, reject) => {
            commit(types.CLEAR_POSITION_LOADER_TIMEOUT);
            commit(types.AUTH_LOGOUT);
            if(rootState.trip.cancel && typeof rootState.trip.cancel === 'function'){
                rootState.trip.cancel();
            }
            commit(types.RESET_STORE);

            resolve();
        });
    },
};

const mutations = {
    [types.SET_TOKENS]: (state, payload) => {
        state.accessToken = payload.accessToken;
        storage.saveToken(payload.accessToken);
        storage.saveRefreshToken(payload.refreshToken);
        apiService.setAuthHeader();
    },

    [types.AUTH_LOGOUT]: (state) => {
        state.accessToken = null;
        storage.clear();
        apiService.clearHeaders();
        apiService.unmountResponseInterceptor();
    }
};

export default {
    state,
    getters,
    actions,
    mutations,
}
